module.exports = __webpack_public_path__ + "static/matbuu-sm-20259ee212e46b8f7413a23c73ee33b7.jpg";